import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import District from '../../interfaces/districts';

interface DistrictAndState {
    districts: District[],
    states: string[]
}

const initialState: DistrictAndState = {
    districts: [],
    states: []
}

export const DistrictAndStateSlice = createSlice({
    name: 'districts',
    initialState,
    reducers: {
        loadDistricts: (state, action: PayloadAction<District[]>) => {
            state.districts = action.payload;
            const stateValues = action.payload.map(val => val.state);
            state.states = Array.from(new Set(stateValues));
        }
    }
});

export const {loadDistricts} = DistrictAndStateSlice.actions;

export default DistrictAndStateSlice.reducer;